import { ButtonTheme, ButtonType } from '@ui-components/PlayButton';
import { UserSurveyFragment } from 'app/graphql/__generated__/types/contento';
import React from 'react';
import {
    Button,
    ButtonWrapper,
    Heading,
    InfoText,
    StyledInfoDescriptionList,
    StyledInfoDescriptionListItem,
    StyledInfoDescriptionText,
} from '../UsabilityTest.styles';

type Props = {
    onClick: (e: React.MouseEvent) => void;
    onCloseSurvey: (value: string) => void;
    survey: UserSurveyFragment;
};

const Info = ({ onClick, onCloseSurvey, survey }: Props) => (
    <>
        <Heading>Vad kul! Så här kommer testet att gå till:</Heading>

        <InfoText>
            <StyledInfoDescriptionList>
                <StyledInfoDescriptionListItem>
                    Du får en uppgift. Innan du utför den vill vi att du bedömer hur lätt eller svårt du tror
                    det kommer vara att utföra den.
                </StyledInfoDescriptionListItem>
                <StyledInfoDescriptionListItem>
                    Starta testet genom att trycka på ”Starta uppgiften” när du känner dig redo och utför
                    uppgiften. När du känner dig klar så väljer du ”Jag är klar med uppgiften”.{' '}
                </StyledInfoDescriptionListItem>
                <StyledInfoDescriptionListItem>
                    Efteråt ber vi dig bedöma hur lätt eller svårt det faktiskt var att utföra uppgiften.
                </StyledInfoDescriptionListItem>
            </StyledInfoDescriptionList>
            <StyledInfoDescriptionText>
                Observera att detta inte är ett test av din förmåga att utföra uppgiften, utan av hur SVT Play
                fungerar.
            </StyledInfoDescriptionText>
        </InfoText>

        <ButtonWrapper>
            <Button
                buttonType={ButtonType.BUTTON}
                theme={ButtonTheme.DEFAULT}
                type="button"
                onClick={() => {
                    onCloseSurvey(survey.id);
                }}
                cancel
            >
                Avbryt
            </Button>

            <Button buttonType={ButtonType.BUTTON} theme={ButtonTheme.WHITE} onClick={onClick}>
                Nästa
            </Button>
        </ButtonWrapper>
    </>
);

export default Info;
